import { FluidIntakeReportScreen } from "app/screens/residents/show/FluidIntakeReportScreen";

export default function FluidIntakereportPage() {
  return <FluidIntakeReportScreen />;
}
